export const PageTitle = {
    // 'sapmp' : {
        '/care/home' : 'DMP Admin', 
        '/home' : 'Manage Your Device Enrollment | AT&T Device Management Program',
        '/browse': 'AT&T Business Console - Browse',
        '/browse/details' : 'AT&T Business Console - Product Detail',
        '/productConfigurator' : 'AT&T Business Console - Product Configurator' ,
        '/cart' : 'AT&T Business Console - Shopping Cart' ,
        '/checkout/billing' : 'AT&T Business Console - Checkout - Billing and Payment',
        '/checkout/serviceConfiguration' : 'AT&T Business Console - Checkout - Service Configuration',
        '/checkout/reviewOrder' : 'AT&T Business Console - Checkout - Order Review',
        '/checkout/confirmOrder' : 'AT&T Business Console - Checkout - Order Confirmation',
        '/manage' : 'AT&T Business Console - Manage products',
        '/manageProduct' : 'AT&T Business Console - Manage product',
        '/user/add' : 'AT&T Business Console - Add a user',
        '/bulkUsers' : 'AT&T Business Console - Add multiple users',
        '/bulkUsers/bulk-action' : 'AT&T Business Console - Bulk users - Action',
        '/bulkUsers/bulk-confirm' : 'AT&T Business Console - Bulk users',
        '/bulkUsers/bulk-review' : 'AT&T Business Console - Bulk users - Review',
        '/bulkUsers/bulk-upload' : 'AT&T Business Console - Bulk users - Upload',
        '/manageUsers/action' : 'AT&T Business Console - Manage users - Action',
        '/manageUsers/products' : 'AT&T Business Console - Manage users - Products',
        '/manageUsers/review' : 'AT&T Business Console - Manage users - Review',
        '/manageUsers/users' : 'AT&T Business Console - Manage users',
        '/dashboard' : 'AT&T Business Console - Console dashboard',
        '/dashboard/dep' : 'AT&T Business Console - Console dashboard',
        '/dashboard/efota' : 'AT&T Business Console - Console dashboard',
        '/efota/enrollment/selectaccounts' : 'AT&T Business Console – E-FOTA Enrollment – Select Accounts',
        '/efota/enrollment/review' : 'AT&T Business Console – E-FOTA Enrollment - Review',
        '/efota/enrollment/confirm' : 'AT&T Business Console – E-FOTA Enrollment - Confirm',
        '/efota/reports' : 'AT&T Business Console – E-FOTA Reports',
        '/efota/reportrequest' : 'AT&T Business Console – E-FOTA Request Reports',
        '/efota/changerequests' : 'AT&T Business Console – E-FOTA Change Requests',
        '/efota/requestdetails' : 'AT&T Business Console – Change Request',
        '/fiveg/enrollment/selectaccounts' : 'AT&T Business Console – 5G Enrollment – Select Accounts',
        '/fiveg/enrollment/review' : 'AT&T Business Console – 5G Enrollment – Review',
        '/fiveg/enrollment/confirm' : 'AT&T Business Console – 5G Enrollment – Confirm', 
        '/care/efota' : 'DMP Admin – E-FOTA Enrollment',
        '/care/efotadetails' : 'DMP Admin – Enrollment Detail',
        '/care/efotareports' : 'DMP Admin – E-FOTA Enrolled Accounts',
        '/changeProduct' : 'AT&T Business Console - Change package',
        '/user/summary' : 'AT&T Business Console',
        '/user/edit' : 'AT&T Business Console - Edit user details',
        '/manageProduct/modifyLicense' : 'AT&T Business Console - Manage Product',
        '/manageProduct/cancel-product' : 'AT&T Business Console - Manage Product',
        '/welcome': 'AT&T Business Console - Welcome',
        '/manageInventory' : 'AT&T Business Console - Manage Devices',
        '/manageInventory/managenotification' : 'AT&T Business Console - Manage Notification',
        '/manageInventory/deviceInventory' : 'AT&T Business Console - Manage Deployment',
        '/groupingDevices/selectDevices' : 'AT&T Business Console - Group Devices',
        '/manageGroups' : 'AT&T Business Console - Manage Groups',
        '/manageInventory/ctnInfo' : 'AT&T Business Console - View CTN information',
        '/manageInventory/fanDeploymentProfile' : 'AT&T Business Console - View Single FAN Profile Information',
        '/manageInventory/manageAccounts' : 'AT&T Business Console - Edit Apple Organization ID',
        '/reports/transaction/reportType' : 'AT&T Business Console - Transaction History Report - Report type',
        '/reports/transaction/dateRange' : 'AT&T Business Console - Transaction History Report - Date range',
        '/reports/transaction/review' : 'AT&T Business Console - Transaction History Report - Review',
        '/reports/transaction/confirmation' : 'AT&T Business Console - Transaction History Report - Confirmation',
        '/appleCertificate/info': 'AT&T Business Console - Apple Certificate - Info',
        '/appleCertificate/upload': 'AT&T Business Console - Apple Certificate - Upload',
        '/cancelParticipation/selectfan': 'AT&T Business Console - Cancel Participation - Select FAN',
        '/cancelParticipation/removeaccount': 'AT&T Business Console - Cancel Participation - Remove account',
        '/cancelParticipation/unclaimdevices': 'AT&T Business Console - Cancel Participation - Unclaim devices',
        '/cancelParticipation/review': 'AT&T Business Console - Cancel Participation - Review',
        '/cancelParticipation/confirm': 'AT&T Business Console - Cancel Participation - Confirm',
        '/cancelParticipation' : 'AT&T Business Console - Cancel Participation',
        '/sendMessage/message' : 'AT&T Business Console - Send Message',
        '/sendMessage/accounts' : 'AT&T Business Console - Select Account',
        '/sendMessage/review' : 'AT&T Business Console - Review Message',
        '/signup/accounts' : 'AT&T Business Console - Accounts',
        '/signup/accounts?tab=revisedFanList' : 'AT&T Business Console - Accounts',
        '/signup/accounts?tab=awaitingSignupFanList': 'AT&T Business Console - Accounts',
        '/signup/settings' : 'AT&T Business Console - Settings',
        '/signup/applications' : 'AT&T Business Console - Applications',
        '/signup/startdate' : 'AT&T Business Console - Start Date',
        '/signup/review' : 'AT&T Business Console - Review',
        '/signup/confirm' : 'AT&T Business Console - Confirm',
        '/signupsetup/enrollmentoptions' : 'AT&T Business Console - Enrollment Options',
        '/signupsetup/review' : 'AT&T Business Console - Review',
        '/signupsetup/confirm' : 'AT&T Business Console - Confirm',
        '/abmfacilitatedenrollment' : 'AT&T Business Console - Apple Business Facilitated Enrollment ' ,
        '/care/searchFan' : 'DMP Admin - Search FAN',
        '/care/dashboard-title' : 'AT&T Business Console - Care - Customer data',
        '/care/select-fan-table' : 'AT&T Business Console - Care - Retrieving foundation accounts',
        '/care/dmpWhitelistFans':'DMP Admin -WhiteLists Admin',
        '/support' : 'AT&T Business Console - Support',
        '/faq' : 'AT&T Business Console - FAQ',
        '/terms' : 'AT&T Business Console - Terms and Conditions',
        '/errorPage/E405' : 'AT&T Business Console - Error',
        '/enrollmentTool' : 'AT&T Business Console - Enrollment Tool',
        '/productselection' : 'AT&T Business Console - Product Selection',
        '/signupsetup' : 'AT&T Business Console - Product Selection',
        '/care/abm':'AT&T Business Console-Admin Apple Business',
        '/care/faciliateEnrollment': 'AT&T Business Console-Admin Fe',
        '/care/kme':'AT&T Business Console-Admin Kme',
        '/care/zte':'AT&T Business Console-Admin Zte',
        '/care/deviceSubmissionTracking':'AT&T Business Console-Admin Device Submission Tracking',
        '/care/oneClickAdminOps':'AT&T Business Console-Admin OneClick Admin Ops',
        '/care/deviceEnrollments':'AT&T Business Console - Pending Apple Business transactions',
        '/learn/androidzerotouch':'Android™ Zero-touch | AT&T Business Console'
    // },
    // 'myatt' : {
    //     '/home' : 'Enroll, Manage and View Mobile Devices | AT&T Business Console',
    //     '/browse': 'AT&T Business Console - Browse',
    //     '/browse/details' : 'AT&T Business Console - Product Detail',
    //     '/productConfigurator' : 'AT&T Business Console - Product Configurator' ,
    //     '/cart' : 'AT&T Business Console - Shopping Cart' ,
    //     '/checkout/billing' : 'AT&T Business Console - Checkout - Billing and Payment',
    //     '/checkout/serviceConfiguration' : 'AT&T Business Console - Checkout - Service Configuration',
    //     '/checkout/reviewOrder' : 'AT&T Business Console - Checkout - Order Review',
    //     '/checkout/confirmOrder' : 'AT&T Business Console - Checkout - Order Confirmation',
    //     '/manage' : 'AT&T Business Console - Manage products',
    //     '/manageProduct' : 'AT&T Business Console - Manage product',
    //     '/user/add' : 'AT&T Business Console - Add a user',
    //     '/bulkUsers' : 'AT&T Business Console - Add multiple users',
    //     '/bulkUsers/bulk-action' : 'AT&T Business Console - Bulk users - Action',
    //     '/bulkUsers/bulk-confirm' : 'AT&T Business Console - Bulk users',
    //     '/bulkUsers/bulk-review' : 'AT&T Business Console - Bulk users - Review',
    //     '/bulkUsers/bulk-upload' : 'AT&T Business Console - Bulk users - Upload',
    //     '/manageUsers/action' : 'AT&T Business Console - Manage users - Action',
    //     '/manageUsers/products' : 'AT&T Business Console - Manage users - Products',
    //     '/manageUsers/review' : 'AT&T Business Console - Manage users - Review',
    //     '/manageUsers/users' : 'AT&T Business Console - Manage users',
    //     '/dashboard' : 'AT&T Business Console - Console dashboard',
    //     '/changeProduct' : 'AT&T Business Console - Change package',
    //     '/user/summary' : 'AT&T Business Console',
    //     '/user/edit' : 'AT&T Business Console - Edit user details',
    //     '/manageProduct/modifyLicense' : 'AT&T Business Console - Manage Product',
    //     '/manageProduct/cancel-product' : 'AT&T Business Console - Manage Product',
    //     '/welcome': 'AT&T Business Console - Welcome',
    //     '/manageInventory' : 'AT&T Business Console - Manage Devices',
    //     '/manageInventory/deviceInventory' : 'AT&T Business Console - Manage Deployment',
    //     '/manageInventory/ctnInfo' : 'AT&T Business Console - View CTN information',
    //     '/manageInventory/fanDeploymentProfile' : 'AT&T Business Console - View Single FAN Profile Information',
    //     '/reports/transaction/reportType' : 'AT&T Business Console - Transaction History Report - Report type',
    //     '/reports/transaction/dateRange' : 'AT&T Business Console - Transaction History Report - Date range',
    //     '/reports/transaction/review' : 'AT&T Business Console - Transaction History Report - Review',
    //     '/reports/transaction/confirmation' : 'AT&T Business Console - Transaction History Report - Confirmation',
    //     '/appleCertificate/info': 'AT&T Business Console - Apple Certificate - Info',
    //     '/appleCertificate/upload': 'AT&T Business Console - Apple Certificate - Upload',
    //     '/cancelParticipation/selectfan': 'AT&T Business Console - Cancel Participation - Select FAN',
    //     '/cancelParticipation/review': 'AT&T Business Console - Cancel Participation - Review',
    //     '/cancelParticipation/confirm': 'AT&T Business Console - Cancel Participation - Confirm',
    //     '/cancelParticipation' : 'AT&T Business Console - Cancel Participation',
    //     '/sendMessage/message' : 'AT&T Business Console - Send Message',
    //     '/sendMessage/accounts' : 'AT&T Business Console - Select Account',
    //     '/sendMessage/review' : 'AT&T Business Console - Review Message',
    //     '/signup/accounts' : 'AT&T Business Console - Accounts',
    //     '/signup/accounts?tab=revisedFanList' : 'AT&T Business Console - Accounts',
    //     '/signup/accounts?tab=awaitingSignupFanList': 'AT&T Business Console - Accounts',
    //     '/signup/settings' : 'AT&T Business Console - Settings',
    //     '/signup/applications' : 'AT&T Business Console - Applications',
    //     '/signup/startdate' : 'AT&T Business Console - Start Date',
    //     '/signup/review' : 'AT&T Business Console - Review',
    //     '/signup/confirm' : 'AT&T Business Console - Confirm',
    //     '/care/search-fan' : 'AT&T Business Console - Care - Select foundation account',
    //     '/care/dashboard-title' : 'AT&T Business Console - Care - Customer data',
    //     '/care/select-fan-table' : 'AT&T Business Console - Care - Retrieving foundation accounts',
    //     '/support' : 'AT&T Business Console - Support',
    //     '/faq' : 'AT&T Business Console - FAQ',
    //     '/terms' : 'AT&T Business Console - Terms and Conditions',
    //     '/errorPage/E405' : 'AT&T Business Console - Error',
    //     '/enrollmentTool' : 'AT&T Business Console - Enrollment Tool',
    //     '/productselection' : 'AT&T Business Console - Product Selection'
    // },
    // 'fnabc' : {
    //     '/home' : 'Apps & Solutions',
    //     '/browse': 'Apps & Solutions - Browse',
    //     '/browse/details' : 'Apps & Solutions - Product Detail',
    //     '/productConfigurator' : 'AT&T Business Console - Product Configurator',
    //     '/cart' : 'Apps & Solutions - Shopping Cart' ,
    //     '/checkout/billing' : 'Apps & Solutions - Checkout - Billing and Payment',
    //     '/checkout/serviceConfiguration' : 'Apps & Solutions - Checkout - Service Configuration',
    //     '/checkout/reviewOrder' : 'Apps & Solutions - Checkout - Order Review',
    //     '/checkout/confirmOrder' : 'Apps & Solutions - Checkout - Order Confirmation',
    //     '/manage' : 'Apps & Solutions - Manage products',
    //     '/manageProduct' : 'Apps & Solutions - Manage product',
    //     '/user/add' : 'Apps & Solutions - Add a user',
    //     '/bulkUsers' : 'Apps & Solutions - Add multiple users',
    //     '/bulkUsers/bulk-action' : 'Apps & Solutions - Bulk users - Action',
    //     '/bulkUsers/bulk-confirm' : 'Apps & Solutions - Bulk users',
    //     '/bulkUsers/bulk-review' : 'Apps & Solutions - Bulk users - Review',
    //     '/bulkUsers/bulk-upload' : 'Apps & Solutions - Bulk users - Upload',
    //     '/manageUsers/action' : 'Apps & Solutions - Manage users - Action',
    //     '/manageUsers/products' : 'Apps & Solutions - Manage users - Products',
    //     '/manageUsers/review' : 'Apps & Solutions - Manage users - Review',
    //     '/manageUsers/users' : 'Apps & Solutions - Manage users',
    //     '/dashboard' : 'Apps & Solutions - Console dashboard',
    //     '/changeProduct' : 'Apps & Solutions - Change package',
    //     '/user/summary' : 'Apps & Solutions',
    //     '/user/edit' : 'Apps & Solutions - Edit user details',
    //     '/manageProduct/modifyLicense' : 'Apps & Solutions - Manage Product',
    //     '/manageProduct/cancel-product' : 'Apps & Solutions - Manage Product',
    //     '/welcome': 'Apps & Solutions - Welcome',
    //     '/manageInventory' : 'Apps & Solutions - Manage Devices',
    //     '/manageInventory/deviceInventory' : 'Apps & Solutions - Manage Deployment',
    //     '/manageInventory/ctnInfo' : 'Apps & Solutions - View CTN information',
    //     '/manageInventory/fanDeploymentProfile' : 'Apps & Solutions - View Single FAN Profile Information',
    //     '/reports/transaction/reportType' : 'Apps & Solutions - Transaction History Report - Report type',
    //     '/reports/transaction/dateRange' : 'Apps & Solutions - Transaction History Report - Date range',
    //     '/reports/transaction/review' : 'Apps & Solutions - Transaction History Report - Review',
    //     '/reports/transaction/confirmation' : 'Apps & Solutions - Transaction History Report - Confirmation',
    //     '/appleCertificate/info': 'Apps & Solutions - Apple Certificate - Info',
    //     '/appleCertificate/upload': 'Apps & Solutions - Apple Certificate - Upload',
    //     '/cancelParticipation/selectfan': 'Apps & Solutions - Cancel Participation - Select FAN',
    //     '/cancelParticipation/review': 'Apps & Solutions - Cancel Participation - Review',
    //     '/cancelParticipation/confirm': 'Apps & Solutions - Cancel Participation - Confirm',
    //     '/cancelParticipation' : 'Apps & Solutions - Cancel Participation',
    //     '/sendMessage/message' : 'Apps & Solutions - Send Message',
    //     '/sendMessage/accounts' : 'Apps & Solutions - Select Account',
    //     '/sendMessage/review' : 'Apps & Solutions - Review Message',
    //     '/signup/accounts' : 'Apps & Solutions - Accounts',
    //     '/signup/accounts?tab=revisedFanList' : 'Apps & Solutions - Accounts',
    //     '/signup/accounts?tab=awaitingSignupFanList': 'Apps & Solutions - Accounts',
    //     '/signup/settings' : 'Apps & Solutions - Settings',
    //     '/signup/applications' : 'Apps & Solutions - Applications',
    //     '/signup/startdate' : 'Apps & Solutions - Start Date',
    //     '/signup/review' : 'Apps & Solutions - Review',
    //     '/signup/confirm' : 'Apps & Solutions - Confirm',
    //     '/care/search-fan' : 'Apps & Solutions - Care - Select foundation account',
    //     '/care/dashboard-title' : 'Apps & Solutions - Care - Customer data',
    //     '/care/select-fan-table' : 'Apps & Solutions - Care - Retrieving foundation accounts',
    //     '/support' : 'Apps & Solutions - Support',
    //     '/faq' : 'Apps & Solutions - FAQ',
    //     '/terms' : 'Apps & Solutions - Terms and Conditions',
    //     '/errorPage/E405' : 'Apps & Solutions - Error',
    //     '/enrollmentTool' : 'Apps & Solutions - Enrollment Tool',
    //     '/productselection' : 'Apps & Solutions - Product Selection'
    //     }
};